import { Input } from "reactstrap"
import styles from "./Search.module.scss"
import { CiSearch } from "react-icons/ci"

const Search = ({ placeholder = 'Search' }) => {
  return (
    <div>
      <div className={`position-relative ${styles.searchInput}`}>
        <Input placeholder={placeholder} className={styles.inputElement} onChange={() => {}} />
        <span className={styles.searchIcon}>
          <CiSearch size={24} />
        </span>
      </div>
    </div>
  )
}

export default Search
